<template>
  <div class="mdc-select"
  :class="classes"
  @MDCSelect:change="onChange">

    <div class="mdc-select__anchor select-width-class">

      <i v-if="$slots.leadingIcon" class="material-icons mdc-select__icon" tabindex="0" role="button">
        <slot name="leadingIcon"/>
      </i>

      <span class="mdc-select__selected-text-container">
        <span class="mdc-select__selected-text">{{value}}</span>
      </span>

      <i class="mdc-select__dropdown-icon"></i>

      <div v-if="outlined" class="mdc-notched-outline">
          <div class="mdc-notched-outline__leading"></div>
          <div class="mdc-notched-outline__notch">
            <label v-if="label" for="input" class="mdc-floating-label" :class="{'mdc-floating-label--float-above': value}">{{label}}</label>
          </div>
          <div class="mdc-notched-outline__trailing"></div>
        </div>
      <label v-else class="mdc-floating-label" :class="{'mdc-floating-label--float-above': value}">{{label}}</label>
      <div v-if="!outlined" class="mdc-line-ripple"></div>

    </div>

    <div ref="menuSurface" class="mdc-select__menu mdc-menu mdc-menu-surface select-width-class">
      <div class="prompt">
        <h4 class="mobile-label" >{{label}}</h4>
        <mdc-body class="mobile-label" typo="body2">Please select</mdc-body>
      </div>
      <ul role="listbox" class="mdc-list">
        <slot/>
      </ul>

    </div>
  </div>
</template>

<script>
import { MDCSelect } from '@material/select'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: undefined
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes () {
      return {
        'mdc-select--outlined': this.outlined,
        'mdc-select--disabled': this.disabled,
        'mdc-select--dense': this.dense,
        'mdc-select--invalid': !this.valid,
        'mdc-select--with-leading-icon': this.$slots.leadingIcon
      }
    }
  },
  data () {
    return {
      scrollLockedBySelect: false
    }
  },
  focus () {
    console.log('Select.focus', this.select)
    this.select.openMenu()
  },
  mounted () {
    this.select = MDCSelect.attachTo(this.$el)
    this.select.value = this.value
    this.val = this.value
    console.log('mounted set val', this.val)
    const self = this
    var observerConfig = {
      attributes: true,
      childList: false
    }
    var observer = new MutationObserver(self.onMenuSurfaceChange)
    observer.observe(this.$refs.menuSurface, observerConfig)
  },
  watch: {
    value () {
      this.val = this.value
      console.log('watch:value set val', this.val)
      this.select.value = this.value
    }
  },
  methods: {
    onChange () {
      this.val = this.select.value
      console.log('onChange set val', this.val)
      this.$emit('change', this.select.value)
    },
    onMenuSurfaceChange (mutationList) {
      const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
      if (this.$refs.menuSurface) {
        if (this.$refs.menuSurface.classList.contains('mdc-menu-surface--open')) {
          this.$emit('focus')
          if (vw <= 570) {
            // If mobile add scroll lock to body
            if (document.getElementsByClassName('body')[0].classList.contains('mdc-dialog-scroll-lock')) {
              document.getElementsByClassName('body')[0].classList.add('mdc-dialog-scroll-lock')
            } else {
              this.scrollLockedBySelect = true
              document.getElementsByClassName('body')[0].classList.add('mdc-dialog-scroll-lock')
            }
          }
        } else {
          if (this.scrollLockedBySelect) {
            document.getElementsByClassName('body')[0].classList.remove('mdc-dialog-scroll-lock')
          }
        }
      }
    }
  }
}
</script>

<style>
.mdc-select {
  min-width: 80px;
}
.select-width-class {
  width:100%;
}

.mdc-select--outlined .mdc-select__anchor {
  margin-bottom:0px !important;
}

.mdc-select.mdc-select--focused.mdc-select--activated {
  height:auto !important;
}

.mdc-select .mdc-select__selected-text.select-width-class {
  overflow: hidden;
  text-overflow: ellipsis;
  width:100%;
  display: block;
  white-space: nowrap;
}

.mdc-select .mdc-select__menu {
  z-index:11;
}

.mdc-select .mdc-list-item {
  min-height:unset;
}

.mdc-select:not(.mdc-select--disabled).mdc-select--focused .mdc-floating-label {
  color: rgba(45,156,219,0.87);
}
.mdc-select:not(.mdc-select--disabled) .mdc-floating-label {
  background: white;
  padding-right: 6px;
}
.mdc-select__dropdown-icon {
  height:10px;
  background-repeat: no-repeat;
  background-position: center;
}
.mdc-select .mdc-select__dropdown-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='10px' height='5px' viewBox='7 10 10 5' version='1.1'%3E%3Cpolygon id='Shape' stroke='none' fill='%23BCBDBC' fill-rule='evenodd' opacity='1' points='7 10 12 15 17 10'/%3E%3C/svg%3E");
}
.mdc-select.mdc-select--focused .mdc-select__dropdown-icon {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='10px' height='5px' viewBox='7 10 10 5' version='1.1'%3E%3Cpolygon id='Shape' stroke='none' fill='%232d9cdb' fill-rule='evenodd' opacity='1' points='7 10 12 15 17 10'/%3E%3C/svg%3E");
}
.mdc-select .mdc-notched-outline__notch {
  min-width:unset;
  margin-right: -5px !important;
}
.mdc-select.mdc-select--dense select{
  padding-right:24px;
}
.mdc-select.mdc-select--dense .mdc-select__dropdown-icon{
  padding-right:0px;
}

.mdc-select.mdc-select--invalid:not(.mdc-select--disabled) .mdc-floating-label {
  color: #b00020 !important;
}

.mdc-select .mdc-floating-label::after {
  top: -2px;
  margin-left: 3px !important;
  position: relative;
}

.mdc-select.mdc-select--invalid:not(.mdc-select--disabled) .mdc-floating-label::after {
  color: #b00020 !important;
}

.mdc-select.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__leading,
.mdc-select.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__notch,
.mdc-select.mdc-select--invalid:not(.mdc-select--disabled) .mdc-notched-outline__trailing {
  border-color: #b00020 !important;
}

.mobile-label {
  display:none;
  padding: 16px;
}

h4.mobile-label {
  padding-bottom: 0;
  margin-bottom: 6px;
  margin-top: 0;
}

p.mobile-label {
  padding-top: 0;
  padding-bottom:0;
  margin-top: 6px;
  color: var(--mdc-theme-text-secondary-on-light, rgba(0, 0, 0, 0.54));
  font-size:0.9em;
}

.mdc-select .mdc-list {
  background: white;
  max-height: 180px;
}

.mdc-select .mdc-list-item {
  background-color:white;
  border-left: 3px solid transparent;
}
.mdc-select .mdc-list-item--selected {
  background-color: #F5F5F5;
  border-left: 3px solid var(--mdc-theme-primary, #2D9CDB);
  color: #333;
}
.mdc-select .mdc-list-item:hover {
  background-color: #F5F5F5 !important;
  border-left: 3px solid var(--mdc-theme-primary, #2D9CDB) !important;
  color: #333;
}

.prompt {
  display:none
}

@media all and (max-width: 570px) {
  .mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.mdc-menu-surface--open {
    position: fixed;
    width: 100%;
    height: 100%;
    max-height: 100% !important;
    max-width: 100% !important;
    top: 0px !important;
    left: 0px !important;
    z-index: 9999;
    display:flex;
    flex-flow: column;
  }
  .mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.mdc-menu-surface--open .mobile-label {
    display:block;
  }
  .mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.mdc-menu-surface--open .mdc-list {
    overflow-y: auto;
    display: flex;
    flex-flow: column;
    flex-grow: 1;
    flex-shrink: 1;
    max-height: unset;
  }
  .mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.mdc-menu-surface--open .mdc-list .mdc-list-item {
    flex-grow: 1;
    flex-shrink: 0;
    border-top:1px solid silver;
    padding-top: 2px;
    padding-bottom: 2px;
    display:flex;
    justify-content: center;
    align-items: flex-start;
    flex-flow:column;
  }
  .mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.mdc-menu-surface--open .mdc-list .mdc-list-item span {
    display:flex;
    flex-flow:column;
    justify-content: center;
  }
  .mdc-select .mdc-select__menu.mdc-menu.mdc-menu-surface.mdc-menu-surface--open .prompt {
    display:block;
  }
}
</style>
